export default "__VITE_ASSET__DQiRoigk__"